import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { ChildEntitiesLabel } from "./ChildEntitiesLabel/ChildEntitiesLabel";

export const makeChildEntitiesLabel = (data: MakeLabelParams) => (
  <ChildEntitiesLabel params={data} />
);
